import Api from '@/api/index';

const Envelope = {
  namespaced: true,
  state: {
    allEnvelopes: [],
    statusByTitle:{}
  },
  getters: {
    
  },

  mutations: {
    setAllEnvelopes(state, envelopes) {
      state.allEnvelopes = [...envelopes]
      
    }

    // this.status_missed_id = state.allEnvelopes.find(s=>s.title == 'Missed').id
    // this.status_bacon_id = state.allEnvelopes.find(s=>s.title == 'Bacon').id
  },

  actions: {
    index(context, filters) {
      return Api.Envelope.index(filters).then(r => r.data).then(r => {
        context.commit('setAllEnvelopes', r.data)
        return true
      }).catch(err => {
        console.log(err)
        throw Error(err)
      })
    }
  }

};

export default Envelope;
